<template>
  <v-dialog v-model="dialog" width="600" scrollable persistent>
    <v-card v-if="dialog">
      <v-card-title>
        Detalhes do contato
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <contato-detalhes v-model="contatoAtivo" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import ContatoDetalhes from "./ContatoDetalhes";
export default {
  components: { ContatoDetalhes },
  computed: {
    dialog: {
      get() {
        return this.$store.state.contato.contatoAtivo !== null;
      },
      set(val) {
        if (!val) {
          this.$store.commit("contato/setContatoAtivo", null);
        }
      },
    },
    ...mapState({
      contatoAtivo: (state) => state.contato.contatoAtivo,
    }),
  },
};
</script>
